module.exports = __webpack_public_path__ + "img/emergency_kit_05.3252c3da.jpg";